exports = module.exports = require("../../node_modules/_css-loader@0.28.7@css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".header{background-color:#242f42}.login-wrap{background:#324157}.plugins-tips{background:#eef1f6}.el-upload--text em,.plugins-tips a{color:#20a0ff}.pure-button{background:#20a0ff}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/_css-loader@0.28.7@css-loader?minimize!./static/css/color-dark.css
// module id = 129
// module chunks = 8 9